import React from 'react';
import PropTypes from 'prop-types';
import ErrorDisplay from '../shared/errorDisplay';

const CommentField = props => {
  const handleChange = event => {
    props.addTempUserComment(event.target.value);
  };

  let bannedWordErrorMessage =
    props.translations['dont-use-banned-words'] ||
    '{1} may not be appropriate for this communication. Please choose a different word.';
  if (props.bannedWordError) {
    bannedWordErrorMessage = bannedWordErrorMessage.replace(
      '{1}',
      props.bannedWordError.charAt(0).toUpperCase() +
        props.bannedWordError.slice(1),
    );
  }

  let maxLengthForComment = props.maxlength;
  if (props.doubleByteExists && !props.isLeaderComment) {
      maxLengthForComment = props.doubleByteMaxLength;
  }

  const isError = props.error.indexOf('(comment-') !== -1;
  const classes = isError ? 'invalid' : '';

  return (
    <div className="inpt comment-inpt">
      <p className="desc">{props.title}</p>
      <span className="req">{props.translations.required}</span>
      {/* eslint-disable jsx-a11y/label-has-for */}
      <label htmlFor="comment-comment">{props.translations.personal}</label>
      {/* eslint-enable jsx-a11y/label-has-for */}
      {props.error.indexOf('(comment-required)') !== -1 && (
        <ErrorDisplay errorMessage={props.translations['this-is-required']} />
      )}
      {props.error.indexOf('(comment-length)') !== -1 && (
        <ErrorDisplay errorMessage={props.translations['message-too-long']} />
      )}
      {props.error.indexOf('(comment-banned-word)') !== -1 && (
        <ErrorDisplay errorMessage={bannedWordErrorMessage} />
      )}
      {props.error.indexOf('(emojis-not-allowed)') !== -1 && (
        <ErrorDisplay errorMessage={props.translations['emojis-not-allowed']} />
      )}
      <textarea
        id="comment-comment"
        className={classes}
        name="comment"
        placeholder={props.translations.personal}
        onChange={handleChange}
        value={props.comment}
        required
      />
      <span
        className={
            maxLengthForComment - props.comment.length < 0 ? 'counter err' : 'counter'
        }
      >
        {maxLengthForComment - props.comment.length}
      </span>
      <div className="suggestion">
        {/* eslint-disable jsx-a11y/click-events-have-key-events */}
        {/* eslint-disable jsx-a11y/no-static-element-interactions */}
        {/* eslint-disable jsx-a11y/anchor-is-valid */}
        <a
          style={{ color: props.color }}
          onClick={() => props.displayModal('comment-suggestion')}
        >
          {/* eslint-enable jsx-a11y/click-events-have-key-events */}
          {/* eslint-enable jsx-a11y/no-static-element-interactions */}
          {/* eslint-enable jsx-a11y/anchor-is-valid */}
          {props.translations['what-to-write']}
        </a>
      </div>
    </div>
  );
};

CommentField.propTypes = {
  translations: PropTypes.objectOf(PropTypes.string).isRequired,
  addTempUserComment: PropTypes.func.isRequired,
  color: PropTypes.string.isRequired,
  maxlength: PropTypes.number.isRequired,
  displayModal: PropTypes.func.isRequired,
  comment: PropTypes.string,
  title: PropTypes.string,
  error: PropTypes.string,
  bannedWordError: PropTypes.string,
  doubleByteExists: PropTypes.bool,
  doubleByteMaxLength: PropTypes.number,
  isLeaderComment: PropTypes.bool,
};

CommentField.defaultProps = {
  comment: '',
  title: '',
  error: '',
  bannedWordError: '',
  doubleByteExists: false,
  doubleByteMaxLength: 200,
  isLeaderComment: false,
};

export default CommentField;
